module.exports = __webpack_public_path__ + "static/media/adobe-photoshop.b0154b35.svg";